<template>
  <v-footer padless style="background: transparent">
    <v-card flat tile class="footer_bg white--text text-center">
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-4 white--text"
          icon
          @click="
            icon === 'fa-download'
              ? $router.push('/descargas').catch(() => {})
              : ''
          "
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla dolores
        sunt ratione facere! Labore ratione minus fugiat quam, soluta quaerat
        quo velit unde nulla veniam molestias suscipit error pariatur corrupti.
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos vitae
        unde minus eos, iusto amet ex id laudantium in optio quae perspiciatis
        ipsa rem quam distinctio delectus similique repudiandae recusandae.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        <strong>SAFETAXI SERVICIOS MOVILES &copy;</strong>
        {{ new Date().getFullYear() }}
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      "fab fa-facebook-square",
      "fab fa-twitter",
      "fab fa-instagram",
      "fa-download",
    ],
  }),
};
</script>

<style scoped>
.footer_bg{
    background: #3b3b3b40 !important;
}
</style>